import React from 'react';

import {MainLayout} from 'widgets/layout';

import {AdminTariffs as Tariffs} from 'features/admin';

const AdminTariffsPage: React.FC = () => {

    return (
        <MainLayout>
            <Tariffs/>
        </MainLayout>
    );
};

export default AdminTariffsPage;